import * as THREE from 'three';
import type { CharacterRig } from './types';

export function resolveVisibleHeadRoot(rig: CharacterRig): THREE.Object3D | null {
  const headRoot = rig._headRoot ?? null;
  if (headRoot == null) return null;
  if (headRoot.userData.characterHeadMount !== true) return headRoot;

  const headMesh = rig._headMesh ?? null;
  if (headMesh == null) return headRoot;

  let current: THREE.Object3D | null = headMesh;
  while (current != null && current.parent !== headRoot) {
    current = current.parent;
  }
  return current ?? headRoot;
}
